import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import List from '@mui/material/List';
import Grid from '@mui/material/Grid';

import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';

import { SimTypography } from 'components/SimTypography';
import SimHero from 'components/SimHero';
import SimPolygon from 'components/svg/shapes/SimPolygon';

const pages = [
	{
		id: 'ParentEducation',
		href: '#ANCHOR_ParentServices_ParentEd',
		title: 'Parent Education',
		imageIcon: 'https://images.news18.com/ibnlive/uploads/2021/09/childautism-163048404816x9.png'
	},
	{
		id: 'CommunityEvents',
		href: '#ANCHOR_ParentServices_Community',
		title: 'Community Events',
		imageIcon: 'https://childdevelopment.com.au/wp-content/uploads/fine-motor-visual-perception.jpg'
	},
	{
		id: 'PersonalizedParentCoach',
		href: '#ANCHOR_ParentServices_Coach',
		title: 'Personalized Parent Coach',
		imageIcon: 'https://www.monash.edu/__data/assets/image/0008/1906712/banner-functional-behaviour-assessment.jpg'
	},
	{
		id: 'NannyServices',
		href: '#ANCHOR_ParentServices_Nanny',
		title: 'Nanny Services',
		imageIcon:
			'https://www.topoccupationaltherapyschool.com/wp-content/uploads/2016/08/Occupational-Therapy-for-Kids.jpg'
	}
];

const Page = ({ children }) => {
	const theme = useTheme();

	const [activeLink, setActiveLink] = useState('');
	useEffect(() => {
		setActiveLink(window && window.location ? window.location.pathname : '');
	}, []);

	const [selectedIndex, setSelectedIndex] = React.useState(1);
	const handleListItemClick = (event, index) => {
		setSelectedIndex(index);
	};

	return (
		<Box bgcolor={theme.palette.background.default}>
			{/*TOP HEADER*/}

			<Box
				position={'relative'}
				sx={{
					backgroundColor: theme.palette.primary.main
				}}>
				<Box paddingLeft={{ xs: 2, sm: 4, lg: 16 }} paddingRight={{ xs: 2, sm: 4, lg: 8 }} paddingBottom={4}>
					<SimHero
						topTitle='Concerned about raising'
						bottomTitle='a child with'
						topContent='We can help you.'
						content='Research shows that children make better progress when families are strongly involved.  Why? Experiences that a parent creates is nourishment for child’s development.  Even the best intending parents often fall short.'
						firstBtnText='Learn more'
					/>
				</Box>

				<Box top={'-50px'}>
					<SimPolygon />
				</Box>
			</Box>

			{/* SIDEBAR */}
			<Box
				paddingTop={'0 !important'}
				marginTop={0}
				bgcolor={theme.palette.background.page}
				/* paddingRight='1vw' */
				boxShadow={2}>
				<Grid container spacing={2}>
					<Grid item xs={12} md={2.1}>
						<Box
							sx={{
								top: { xs: '10vh', md: '0vh' },
								height: { xs: 'auto', md: '1050vh' },
								position: 'relative',
								display: { xs: 'none', sm: 'none', md: 'block' }
							}}>
							<Box
								marginTop={3}
								sx={{
									top: { xs: '5vh', md: '12vh' },
									height: { xs: 'auto', md: 'auto' },
									position: { xs: 'fixed', md: 'sticky' },

									display: { xs: 'none', sm: 'none', md: 'block' },

									bgcolor: { xs: theme.palette.background.page, md: 'none' },
									zIndex: { xs: 5, md: 0 }
								}}>
								<Card marginTop={6}>
									<Box sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.default' }}>
										<List component='nav' aria-label='main mailbox folders'>
											{pages.map((item, i) => (
												<Box>
													<ListItemButton
														selected={selectedIndex === 0}
														onClick={event => handleListItemClick(event, 0)}
														key={item.id}
														alignItems='flex-start'
														href={item.href}>
														<ListItemAvatar>
															<Avatar alt='Remy Sharp' src={item.imageIcon} />
														</ListItemAvatar>

														<ListItemText>
															<SimTypography
																variant='subtitle2'
																color={activeLink === item.href ? 'white' : 'black'}>
																{item.title}
															</SimTypography>
														</ListItemText>
													</ListItemButton>
													{pages.length === i + 1 ? null : (
														<Divider variant='inset' component='li' />
													)}
												</Box>
											))}
										</List>
									</Box>
								</Card>
							</Box>
						</Box>
					</Grid>
					<Grid item xs={12} md={9.9}>
						{/* <Card sx={{ boxShadow: 2, padding: 0 }}>{children}</Card> */}
						{children}
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
};

Page.propTypes = {
	children: PropTypes.node
};

export default Page;
